import { render, staticRenderFns } from "./FootprintWorld.vue?vue&type=template&id=6cda2482&scoped=true&"
import script from "./FootprintWorld.vue?vue&type=script&lang=js&"
export * from "./FootprintWorld.vue?vue&type=script&lang=js&"
import style0 from "./FootprintWorld.vue?vue&type=style&index=0&id=6cda2482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cda2482",
  null
  
)

export default component.exports